import axios from '~/utils/axios';
import { urlWithParams } from '~/utils';
import { TransactionsFilters, Transaction, Transfer } from '~/types';
import { Target } from '~/types/profile';

type Response = {
  cursors: {
    next?: string;
  };
  transactions?: Transaction[];
  transfers?: Transfer[];
};

interface getTransactionsProps {
  target: Target;
  resourceId?: string;
  accountId?: string;
  type?: 'transactions' | 'transfers';
  next?: string | null;
  filters?: TransactionsFilters;
}

export const getTransactions = (props: getTransactionsProps) => {
  const { target, resourceId, filters, next, type = 'transactions' } = props;
  const resultURL = resourceId ? `${target}/${resourceId}/${type}` : `${target}/${type}`;
  return axios.get<Response>(urlWithParams(resultURL, { next, limit: 50, ...filters }));
};
